import {
  InsertData,
  InsertDataWithImage,
} from "../../Hooks/InsertData";
import { GetData } from "../../Hooks/getAllData";
import { CREATE_SLIDE, DELETE_SLIDE, UPDATE_SLIDE, GET_SLIDE } from "../type";

//create new user
export const createSlideAction = (data) => async (dispatch) => {
  try {
    const response = await InsertDataWithImage(`/api/add-setting/`, data);
    dispatch({
      type: CREATE_SLIDE,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: CREATE_SLIDE,
      payload: e.response,
    });
  }
};
export const deleteSlideAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/delete-setting/`, data);
    dispatch({
      type: DELETE_SLIDE,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: DELETE_SLIDE,
      payload: e.response,
    });
  }
};
export const updateSlideAction = (data) => async (dispatch) => {
  try {
    const response = await InsertDataWithImage(`/api/update-setting/`,data);
    dispatch({
      type: UPDATE_SLIDE,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_SLIDE,
      payload: e.response,
    });
  }
};
export const GetAllSlideAction = (data) => async (dispatch) => {
  try {
    const response = await GetData(`/api/get-settings/`);
    dispatch({
      type: GET_SLIDE,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: GET_SLIDE,
      payload: e.response,
    });
  }
};
